<template>
  <div class="login-container">
    <div class="login-box">
      <img src="../assets/icon/brand_white.png" alt="로고" class="logo" />
      <input v-model="username" type="text" placeholder="아이디" />
      <input v-model="password" type="password" placeholder="비밀번호" @keyup.enter="login"/>
      <button @click="login">로그인</button>
      <p v-if="error" class="error">{{ error }}</p>
    </div>
  </div>
</template>

<script>

//import Cookies from "js-cookie";


export default {
  data() {
    return {
      username: "",
      password: "",
      error: "",
    };
  },
  methods: {
// login() 메서드 수정

    async login() {
      try {
        const res = await fetch("https://s.stni.co.kr/login.php", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            username: this.username,
            password: this.password,
          }),
        });
        const data = await res.json();
        if (data.success) {

          // 로그인 성공 시 사용자 정보도 같이 이벤트로 전달
          this.$emit("login-success", {
            username: this.username,
            grade: data.grade,
            nickname: data.nickname,
            password: data.password,
          });
        } else {
          this.error = data.message;
        }
      } catch (e) {
        this.error = "서버 연결 오류입니다.";
      }
    },

  },
};
</script>

<style scoped>
.logo {
  width: 100%;
  height: 100%;
  vertical-align: middle;
  margin-bottom: 30px; /* 이미지 밑 간격 */
}
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: #1e1e2f;
}

.login-box {
  background: #2c3e50;
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
  width: 300px;
  text-align: center;
  color: white;
}

.login-box h2 {
  margin-bottom: 20px;
  color: white;
}

.login-box input {
  width: 100%;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #555;
  border-radius: 6px;
  font-size: 16px;
  background-color: #3b3b4f;
  color: white;
}

.login-box input::placeholder {
  color: #ccc;
}

.login-box button {
  width: 100%;
  padding: 10px;
  margin: 10px 0;
  background-color: #3498db;
  color: white;
  border: none;
  font-size: 16px;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.login-box button:hover {
  background-color: #2980b9;
}

.error {
  margin-top: 10px;
  color: #ff6b6b;
  font-size: 14px;
}
</style>
